import { render, staticRenderFns } from "./Daili.vue?vue&type=template&id=b556ef74&scoped=true&"
import script from "./Daili.vue?vue&type=script&lang=js&"
export * from "./Daili.vue?vue&type=script&lang=js&"
import style0 from "./Daili.vue?vue&type=style&index=0&id=b556ef74&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b556ef74",
  null
  
)

export default component.exports